export const getAccrualsType = (isPassive) => (isPassive ? 'passive' : 'referral');
